import type { Permission } from "~/types/auth.type";

export const canAccessEditValveDrawer = (permissions: Permission) =>
  permissions.valve?.uid?.update ??
  permissions.valve?.gatewayId?.update ??
  permissions.valve?.heatingNetworkId?.update ??
  permissions.valve?.commands?.temperatureCorrectionCoef?.update ??
  permissions.valve?.delete;
